import { KeysToCamelCase, Metric } from '@statsbomb/parachute-types';

export type MetricDefinition = KeysToCamelCase<Metric>;

export const PHYSICAL_SOURCE = 'physical' as const;

export type MetricLookupMap = Map<string, MetricDefinition>;

export type MetricNormalised = { [key: string]: number | null };

export interface NullableMetricDistributionRange {
  name: string;
  min: number | undefined | null;
  max: number | undefined | null;
}

export type MetricOptionData = {
  label: string;
  value: string;
  is360: boolean;
};

export type MinMax = {
  min: number;
  max: number;
};
